package constants

import kotlinx.css.RuleSet

data class RuleSetClass(val style: RuleSet)